// extracted by mini-css-extract-plugin
export var black = "_4h-6";
export var brand = "_4h-1";
export var ddefault = "_4h-0";
export var error = "_4h-3";
export var gray = "_4h-2";
export var highContrast = "_4h-8";
export var outline = "_4h-7";
export var success = "_4h-5";
export var warning = "_4h-4";